import SystemCompanyInfoApi from '@/api/supplier/systemCompanyInfoApi.js'
import { normalizeSchemeCustomerItem, normalizeSchemeKeyCustomerItem } from '../adapters/index.js'

export async function fetchSchemeCustomerList(serviceId, raw = false) {
  if (!serviceId) return { rows: [], totalRows: 0, raw: null }

  const res = await SystemCompanyInfoApi.listRecommendByServiceId(serviceId)
  if (res?.code !== '00000') return { rows: [], totalRows: 0, raw: res }

  const rows = Array.isArray(res.rows) ? res.rows : []
  return {
    rows: raw ? rows : rows.map(normalizeSchemeCustomerItem).filter(Boolean),
    totalRows: res.totalRows || rows.length || 0,
    raw: res
  }
}

export async function fetchSchemeKeyCustomerList(serviceId, params = {}) {
  if (!serviceId) return { rows: [], totalRows: 0, raw: null }

  const res = await SystemCompanyInfoApi.listKeyRecommendByServiceId(serviceId, params)
  if (res?.code !== '00000') return { rows: [], totalRows: 0, raw: res }

  const rows = Array.isArray(res.rows) ? res.rows : []
  return {
    rows: rows.map(normalizeSchemeKeyCustomerItem).filter(Boolean),
    totalRows: res.totalRows || rows.length || 0,
    raw: res
  }
}

export async function fetchSchemeKeyCustomerOverview(serviceId) {
  if (!serviceId) return null

  const res = await SystemCompanyInfoApi.keyRecommendOverview(serviceId)
  // axios拦截器：无code字段时返回完整response，数据在data下；有code时返回response.data
  const data = res?.model
  if (!data) return null

  return {
    total: data.totalCount || 0,
    newCount: data.newPushCount || 0,
    viewedCount: data.viewedCount || 0,
    collaboratedCount: data.collaborationCount || 0
  }
}
